"use strict";

exports.__esModule = true;
exports.maxFileSize = exports.supportedFileTypes = void 0;
var maxFileSize = 31457280; // 30MB

exports.maxFileSize = maxFileSize;
var supportedFileTypes = [{
  group: 'word',
  extensions: ['doc', 'dot', 'docx', 'docm', 'dotx', 'dotm', 'docb'],
  mimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.wordprocessingml.template', 'application/vnd.ms-word.document.macroenabled.12', 'application/vnd.ms-word.template.macroenabled.12', '']
}, {
  group: 'excel',
  extensions: ['csv', 'xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xla', 'xlam', 'xll', 'xlw'],
  mimeTypes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.spreadsheetml.template', 'application/vnd.ms-excel.sheet.macroEnabled.12', 'application/vnd.ms-excel.template.macroEnabled.12', 'application/vnd.ms-excel.addin.macroEnabled.12', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12']
}, {
  group: 'powerpoint',
  extensions: ['ppt', 'pot', 'pps', 'pptx', 'pptm', 'potx', 'potm', 'ppam', 'ppsx', 'ppsm', 'sldx', 'sldm'],
  mimeTypes: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.presentationml.template', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', 'application/vnd.ms-powerpoint.addin.macroEnabled.12', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12', 'application/vnd.ms-powerpoint.template.macroEnabled.12', 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12']
}, {
  group: 'visio',
  extensions: ['vsd', 'vss', 'vst', 'vdx', 'vsx', 'vtx'],
  mimeTypes: ['application/vnd.visio', 'application/vnd.visio2013']
}, {
  group: 'pdf',
  extensions: ['pdf'],
  mimeTypes: ['application/pdf']
}, {
  group: 'image',
  extensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'tif', 'tiff'],
  mimeTypes: ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/tiff']
}, {
  group: 'text',
  extensions: ['txt', 'msg'],
  mimeTypes: ['text/plain']
}, {
  group: 'oo-doc',
  extensions: ['odt', 'ott', 'oth', 'odm'],
  mimeTypes: ['application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.text-template', 'application/vnd.oasis.opendocument.text-web', 'application/vnd.oasis.opendocument.text-master']
}, {
  group: 'oo-sht',
  extensions: ['ods', 'ots'],
  mimeTypes: ['application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.spreadsheet-template']
}, {
  group: 'oo-pres',
  extensions: ['odp', 'otp'],
  mimeTypes: ['application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.presentation-template']
}, {
  group: 'oo-gfx',
  extensions: ['odg', 'otg'],
  mimeTypes: ['application/vnd.oasis.opendocument.graphics', 'application/vnd.oasis.opendocument.graphics-template']
}, {
  group: 'pages',
  extensions: ['pages'],
  mimeTypes: ['vnd.apple.pages']
}, {
  group: 'numbers',
  extensions: ['numbers'],
  mimeTypes: ['vnd.apple.numbers']
}, {
  group: 'keynote',
  extensions: ['keynote'],
  mimeTypes: ['vnd.apple.keynote']
}, {
  group: 'movie',
  extensions: ['flv', 'mp4', 'm3u8', 'ts', '3gp', 'mov', 'avi', 'wmv'],
  mimeTypes: ['video/x-flv', 'video/mp4', 'application/x-mpegURL', 'video/MP2T', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv']
}];
exports.supportedFileTypes = supportedFileTypes;